<template>
    <IconComponent path="" :className="`${className}`" noRtlTransform :icon="logoSrc" />
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
    className: String,
    class: String,
    noRtlTransform: Boolean
});

const logoSrc = ref("header_name_logo_alpha.svg");

const updateLogo = () => {
    // Check if document.body exists before accessing its className
    if (!document.body) {
        return;
    }
    
    const bodyClass = document.body.className;
    if (bodyClass.includes("light")) {
        logoSrc.value = "logo_black_alpha.svg";
    } else if (
        bodyClass.includes("traderverse") ||
        bodyClass.includes("dark")
    ) {
        logoSrc.value = "header_name_logo_alpha.svg";
    }
};

// Watch for changes in body class to update logo
const observer = new MutationObserver(() => {
    updateLogo();
});

onMounted(() => {
    // Wait for next tick to ensure DOM is ready
    setTimeout(() => {
        // Initial logo setup
        updateLogo();
        
        // Start observing body class changes only if body exists
        if (document.body) {
            observer.observe(document.body, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }, 0);
});

// Cleanup observer when component is unmounted
onUnmounted(() => {
    observer.disconnect();
});
</script>
